module.exports = __webpack_public_path__ + "static/media/order-step-3.7559cc55.png";